import LegalPage from "views/legal/LegalPage";
import { privacyPolicyPage } from "views/legal/legalContent";

function Landing() {
  return <LegalPage page={privacyPolicyPage} />;
}

export default Landing;
